/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */
import './admin.tpl.html';
import './apis/apis.js';
import './batch/batch.js';
import './log/log.js';
import './start/batch/batchStart.js';
import './start/log/logStart.tpl.html';

angular
  .module('admin', [
    'ui.router',
    'admin.apis',
    'admin.batch',
    'admin.batchstart',
    'admin.log',
    'shared.modal',
    'shared.trialendmodal'
  ])
  // This defines the main abstract main view that is shared across all
  // subviews.
  .config([
    '$stateProvider',
    'VIEW_STATES',
    function ($stateProvider, VIEW_STATES) {
      $stateProvider
        .state(VIEW_STATES.ADMIN, {
          abstract: true,
          resolve: {
            paymentInfo: [
              'billingUtils',
              function (billingUtils) {
                return billingUtils.getPaymentInfo();
              }
            ]
          },
          views: {
            content: {
              templateUrl: 'admin/admin.tpl.html',
              controller: 'AdminCtrl'
            }
          }
        })
        // The views that are rendered in the admin view.
        .state(VIEW_STATES.ADMIN_HOME, {
          url: '/admin',
          resolve: {
            // Counts for primary objects for the most recent batches (corresponding to the batches in batchesInfo)
            batchPrimaryObjectCounts: [
              'batchUtils',
              'BATCH_LIMITS',
              function (batchUtils, BATCH_LIMITS) {
                return batchUtils.getBatchPrimaryObjectCounts(BATCH_LIMITS.NUM_BATCHES_ON_DASHBOARD);
              }
            ],
            // Batches to be shown in the admin batch history boinks
            batchesInfo: [
              'batchUtils',
              'BATCH_LIMITS',
              function (batchUtils, BATCH_LIMITS) {
                return batchUtils.getBackupBatchDots(BATCH_LIMITS.NUM_BATCHES_ON_DASHBOARD);
              }
            ],
            dashboardPrefs: [
              'dashboardUtils',
              function (dashboardUtils) {
                return dashboardUtils.getDashboardPreferences();
              }
            ],
            orgInfo: [
              'accountUtils',
              function (accountUtils) {
                return accountUtils.getOrgInfo(true);
              }
            ]
          },
          views: {
            apis: {
              templateUrl: 'admin/apis/apis.tpl.html',
              controller: 'AdminAPIsCtrl'
            },
            batch: {
              templateUrl: 'admin/batch/batch.tpl.html',
              controller: 'AdminBatchCtrl'
            },
            log: {
              templateUrl: 'admin/log/log.tpl.html',
              controller: 'AdminLogCtrl'
            },
            progress: {
              templateUrl: 'shared/progress/progress.tpl.html',
              controller: 'SharedProgressCtrl'
            }
          }
        })
        // The views that are rendered for the start view.
        .state(VIEW_STATES.ADMIN_START, {
          url: '/start',
          views: {
            apis: {
              templateUrl: 'admin/apis/apis.tpl.html',
              controller: 'AdminAPIsCtrl'
            },
            batch: {
              templateUrl: 'admin/start/batch/batchStart.tpl.html',
              controller: 'AdminBatchStartCtrl'
            },
            log: {
              templateUrl: 'admin/start/log/logStart.tpl.html',
              controller: 'AdminLogCtrl'
            },
            progress: {
              templateUrl: 'shared/progress/progress.tpl.html',
              controller: 'SharedProgressCtrl'
            }
          }
        });
    }
  ])
  .controller('AdminCtrl', [
    '$scope',
    '$filter',
    '$rootScope',
    '$state',
    'progressFactory',
    'PROGRESS_ACTIONS',
    'VIEW_STATES',
    '$uibModal',
    'billingUtils',
    'paymentInfo',
    'IntercomFactory',
    function (
      $scope,
      $filter,
      $rootScope,
      $state,
      progressFactory,
      PROGRESS_ACTIONS,
      VIEW_STATES,
      $uibModal,
      billingUtils,
      paymentInfo,
      IntercomFactory
    ) {
      // Make a local reference to the progress ACTIONS constant.
      $scope.ACTIONS = PROGRESS_ACTIONS;

      /**
       * Function to launch the trial end modal.
       */
      $scope.openTrialEndModal = function () {
        $uibModal.open({
          templateUrl: 'shared/modal/trialEndModal.tpl.html',
          controller: 'TrialEndModalCtrl',
          windowClass: 'sbsf-trial-end-modal-window',
          backdrop: 'static',
          keyboard: false
        });
      };

      /**
       * Utility function used to update billing related scope values.
       *
       * @param {Object} paymentInfo - The paymentInfo object returned from the server.
       */
      $scope.updateBillingInfo = function (paymentInfo) {
        $scope.inTrial = billingUtils.inTrial();
        $scope.isExpiredOrg = billingUtils.isExpired();
        $rootScope.renewSupportContact = $filter('i18n')('RENEW_SUPPORT_CONTACT');
      };

      $scope.updateBillingInfo(paymentInfo);

      IntercomFactory.isFeatureEnabled().then(function (featureEnabledFlag) {
        if (featureEnabledFlag) {
          IntercomFactory.boot();
        }
      });
    }
  ]);
